'use client';

import { useCallback } from 'react';

import { ReportReasonEnumItem } from '@ps/api/types';
import { useCurrentUserId } from '@ps/ui/contexts/auth';

import { useCommunityContext } from '../contexts/community/useCommunityContext';
import { reportChannelMessage } from '../functions/message/reportChannelMessage';

/**
 * File a report on a channel message. The `reason` defaults to
 * `inappropriate` — the slice-3 UI just exposes the action as a
 * single menu item without asking the user to pick a reason. A
 * later slice can layer on a reason picker.
 */
export function useReportChannelMessage({
  channelId,
  messageId,
}: {
  channelId: string | null | undefined;
  messageId: string | null | undefined;
}) {
  const { creatorId } = useCommunityContext();
  const currentUserId = useCurrentUserId();
  return useCallback(
    async ({ reason }: { reason?: ReportReasonEnumItem } = {}) => {
      if (!creatorId || !currentUserId || !channelId || !messageId) return;
      await reportChannelMessage({
        creatorId,
        channelId,
        messageId,
        reason: reason ?? ReportReasonEnumItem.Inappropriate,
      });
    },
    [creatorId, currentUserId, channelId, messageId],
  );
}
